import React, {useContext, useEffect} from 'react';
import { useIdle } from 'react-use';
import EnvironmentVariablesContext from
    '../contexts/EnvironmentVariablesContext';
import BackgroundVideo from "./BackgroundVideo";
import {useQuery} from "@apollo/client";
import applicationStateQuery from "../graphql/queries/applicationStateQuery";
import { IDLE_TYPES } from "../constants/applicationState";
import applicationStateUpdate from "../graphql/updates/applicationStateUpdate";
import isQueryReady from "../utils/isQueryReady";
import {matchPath} from "react-router-dom";
import {useLocation} from "react-router";

const ScreenSaver = ({children, disabledForPaths}) => {
  const {
    REACT_APP_SCREEN_SAVER_IDLE_TIMEOUT,
    REACT_APP_SCREEN_SAVER_VIDEO_URL
  } = useContext(EnvironmentVariablesContext);
  const applicationState = useQuery(applicationStateQuery);
  const location = useLocation();

  const idle = (
    isQueryReady(applicationState) &&
    applicationState.data.applicationState.idle
  )
    ? applicationState.data.applicationState.idle
    : IDLE_TYPES.NONE;
  let idleTimeout = parseFloat(REACT_APP_SCREEN_SAVER_IDLE_TIMEOUT);

  const localIdle = useIdle(
    idle === IDLE_TYPES.FORCED ? 1000 : idleTimeout * 1000,
    idle === IDLE_TYPES.FORCED
  );
  useEffect(() => {
    if (idle !== IDLE_TYPES.FORCED_NONE) {
        applicationStateUpdate({
        idle: localIdle ? IDLE_TYPES.STANDARD: IDLE_TYPES.NONE,
      })
    }
  }, [localIdle]);

  if(
    isNaN(idleTimeout) ||
    matchPath(location.pathname, {
      path: disabledForPaths,
      exact: true,
    }) ||
    idle === IDLE_TYPES.NONE ||
    idle === IDLE_TYPES.FORCED_NONE
  ) {
    return children;
  }

  return (
    <BackgroundVideo source={REACT_APP_SCREEN_SAVER_VIDEO_URL} autoPlay loop />
  )
}

export default ScreenSaver;
